import { render } from "./WordPage.vue?vue&type=template&id=2d1460ee&ts=true"
import script from "./WordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/WordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d1460ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d1460ee', __exports__)) {
    api.reload('2d1460ee', __exports__)
  }
  
  module.hot.accept("./WordPage.vue?vue&type=template&id=2d1460ee&ts=true", () => {
    api.rerender('2d1460ee', render)
  })

}


export default __exports__